import { render, staticRenderFns } from "./risk-details-modal.vue?vue&type=template&id=34fb7b88"
import script from "./risk-details-component.ts?vue&type=script&lang=ts&external"
export * from "./risk-details-component.ts?vue&type=script&lang=ts&external"
import style0 from "./risk-details-modal.vue?vue&type=style&index=0&id=34fb7b88&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34fb7b88')) {
      api.createRecord('34fb7b88', component.options)
    } else {
      api.reload('34fb7b88', component.options)
    }
    module.hot.accept("./risk-details-modal.vue?vue&type=template&id=34fb7b88", function () {
      api.rerender('34fb7b88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/table/plant-item-risk-details-modal/risk-details-modal.vue"
export default component.exports